export const GENDER = {
  Any: 0,
  Male: 1,
  Female: 2
};

export const IMAGE_API_URL = process.env.VUE_APP_API_IMAGE_URL;

export const colors = {
  textBlueButton: '#006EFF',
  textColor: '#1c1363',
  backgroundGrey: '#f5f5f6',
  iconColor: '#80B7FF',
  textLastVisit: '#77A0D6',
  backgroundBlueButton: '#E6F1FF',
  iconArinet: '#D3D4DE',
  callIcon: '#fff'
};

export const advertisementMovement = [
  { id: 0, ru: 'Транспортный робот', en: 'Transport robot' },
  { id: 1, ru: 'Воздушных робот', en: 'Air robot' },
  { id: 2, ru: 'Водный робот', en: 'Water robot' }
];

export const rentState = [
  { id: 0, ru: 'Новый', en: 'New' },
  { id: 1, ru: 'Ждет подтверждения', en: 'Wait accept' },
  { id: 2, ru: 'Ожидается платеж', en: 'Payment is expected' },
  { id: 3, ru: 'Отменент', en: 'Cancel' },
  { id: 4, ru: 'Оплачен', en: 'Payment' }
];

export const manipulatorRole = {
  owner: 0,
  admin: 1,
  member: 2,
  follower: 3
};

export const GENDERArray = [
  { id: 0, en: 'Any', ru: 'Любой' },
  { id: 1, en: 'Male', ru: 'Мужской' },
  { id: 2, en: 'Female', ru: 'Женский' }
];

export const FamilyStatus = [
  { id: 0, ru: 'Не выбрано', male: 0 },
  { id: 1, ru: 'Не женат', male: 1 },
  { id: 2, ru: 'Не замужем', male: 2 },
  { id: 3, ru: 'Встречаюсь', male: 0 },
  { id: 4, ru: 'Помолвлен (-a)', male: 1 },
  { id: 6, ru: 'Женат', male: 1 },
  { id: 7, ru: 'Замужем', male: 2 },
  { id: 8, ru: 'В гражданском браке', male: 0 },
  { id: 9, ru: 'Влюблен', male: 1 },
  { id: 10, ru: 'Влюблена', male: 2 },
  { id: 11, ru: 'Все запутано', male: 0 },
  { id: 12, ru: 'Жду, ищу', male: 0 }
];

export const visibility = {
  showAll: '4fdc2be6-2a61-4345-aacf-82f209023fc1'
};

export const CHAT_ROLE = {
  Member: 0,
  Admin: 1
};

export const CONVERSATION_ROLE = {
  Dialog: 0,
  Chat: 1
};

export const GROUP_ROLE = {
  Member: 0,
  Moderator: 1,
  Admin: 2
};

export const MESSAGE_RELATIONSHIP_TYPE = {
  Reply: 0,
  Forward: 1,
  ParentDelete: 2
};

export const MONTHS = [
  { id: 1, ru: 'Январь', en: 'January' },
  { id: 2, ru: 'Февраль', en: 'February' },
  { id: 3, ru: 'Март', en: 'March' },
  { id: 4, ru: 'Апрель', en: 'April' },
  { id: 5, ru: 'Май', en: 'May' },
  { id: 6, ru: 'Июнь', en: 'June' },
  { id: 7, ru: 'Июль', en: 'July' },
  { id: 8, ru: 'Август', en: 'August' },
  { id: 9, ru: 'Сентябрь', en: 'September' },
  { id: 10, ru: 'Октябрь', en: 'October' },
  { id: 11, ru: 'Ноябрь', en: 'November' },
  { id: 12, ru: 'Декабрь', en: 'December' }
];

export const CategotyManipulator = [
  { id: 1, ru: 'Путешествие', en: '' },
  { id: 2, ru: 'Экскурсии', en: '' },
  { id: 3, ru: 'Спорт и игры', en: '' },
  { id: 4, ru: 'Работа', en: '' },
  { id: 5, ru: 'Активный отдых', en: '' }
];

export const GROUP_CATEGORIES = {
  General: '61218b7f-3a9f-42fe-88bd-e6cd8219a472'
};

export const MANIPULATOR_PARTS = {
  Engines: 1,
  Hands: 2,
  Camera: 4,
  All: 7
};
export const EVENT_TYPES = {
  NewFriendRequest: 0,
  FriendRequestApproval: 1,
  LikePhoto: 2,
  LikePost: 3,
  LikeComment: 4,
  LikeAvatar: 5,
  CommentPhoto: 6,
  CommentPost: 7,
  CommentReply: 8,
  MissedCall: 9,
  GroupInvite: 10
};

export const MESSAGE_PHOTO_TYPES = {
  ALBUM: 'ALBUM',
  UPLOADED: 'UPLOADED'
};

export const MESSAGE_CONTENT = {
  Text: 0,
  Photo: 1,
  File: 2
};

export const BROADCAST_STATES = {
  Active: 0,
  Expected: 1,
  Completed: 2
};
